import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { registerServiceWorker } from "./utils/pwaUtils";
import { initializeFCM } from "./services/fcmService";
import { initSentry } from "./services/sentry";

// Initialize error monitoring before anything else so early crashes are captured.
initSentry();

// Trigger update event
const triggerUpdateEvent = (registration) => {
  window.dispatchEvent(
    new CustomEvent("sw-update-available", { detail: registration })
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for PWA
if (import.meta.env.PROD) {
  registerServiceWorker(triggerUpdateEvent);
}

// Initialize FCM for push notifications
initializeFCM().catch((error) => {
  console.error("Failed to initialize FCM:", error);
});
